import React, { memo, useCallback, useMemo } from 'react';
import './MusicianCard.css';
import { useNavigate } from 'react-router-dom';
import OptimizedImage from './OptimizedImage';

function TeacherCard({ teacher }) {
  const navigate = useNavigate();

  // Mémorisation du callback pour éviter les re-créations inutiles
  const goToProfile = useCallback(() => {
    navigate(`/teachers/${teacher.id}`);
  }, [navigate, teacher.id]);

  // Mémorisation de l'URL de l'image pour éviter les recalculs
  const imageSrc = useMemo(() => 
    teacher.imageURL ? `/images/teachers/${teacher.imageURL}` : '/default-profile.png',
    [teacher.imageURL]
  );

  return (
    <div className="musician-card">
      <OptimizedImage
        src={imageSrc}
        alt={teacher.name}
        className="musician-image"
        fallback="/default-profile.png"
      />
      <h3>{teacher.name}</h3>
      <p><strong>Matière :</strong> {teacher.subject}</p>
      <p><strong>Ville :</strong> {teacher.city}</p>
      {teacher.bio && <p className="bio">{teacher.bio}</p>}

      <button className="profile-button" onClick={goToProfile}>
        Voir le profil
      </button>
    </div>
  );
}

export default memo(TeacherCard);